import { ConfirmTransactionRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Removes the fraud flag from a transaction (the backend calls this
// "confirming" it).
export default function useConfirmTransaction() {
  const api = useApi();
  const [confirming, setConfirming] = useState(false);

  async function confirmTransaction(params: ConfirmTransactionRequest) {
    try {
      setConfirming(true);
      const res = await api.postConfirmTransaction(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setConfirming(false);
    }
  }

  return { confirming, confirmTransaction };
}
